// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jessibuca-player-container[data-v-4d39d620]{width:100%;height:100%;min-height:169px;min-width:300px;background:#000}.jessibuca-dom[data-v-4d39d620]{width:100%;height:100%}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
